<template>
  <div>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item label="訂單號">
        <el-input v-model="searchData.id" placeholder="5"></el-input>
      </el-form-item>
      <el-form-item label="訂單編號">
        <el-input
          v-model="searchData.transaction_id"
          placeholder="T2020123564984231"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getData">搜尋</el-button>
      </el-form-item>
    </el-form>
    <el-descriptions :column="2" border>
      <el-descriptions-item
        :label="key"
        v-for="(data, key) in currentData[0]"
        :key="key"
      >
        <p>{{ data }}</p>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      inSearch: false,
      saveData: false,
      searchData: {},
      dataList: [],
      currentData: {}
    };
  },
  methods: {
    getData() {
      this.$http
        .get(`/back/admin/collections`, {
          params: this.searchData
        })
        .then(res => {
          if (res.data.code == 0) {
            this.currentData = res.data.data;
          }
        });
    }
  }
};
</script>
